import {Component, inject} from '@angular/core';
import {MultiTreeSelect} from '../ui/multi-tree-select/multi-tree-select';
import {FacetKey, FacetNode} from '../domain/search.model';
import {SearchFacade} from '../application/search.facade';

@Component({
  selector: 'app-search-page',
  imports: [
    MultiTreeSelect
  ],
  templateUrl: './search-page.html',
  styleUrl: './search-page.scss',
})
export class SearchPage {
  private readonly _facade = inject(SearchFacade);

  protected readonly facetKeys = Object.values(FacetKey);

  protected readonly facetLabels: Record<FacetKey, string> = {
    [FacetKey.PRODUCTS]: 'Wärmeerzeuger Einzelgeräte',
    [FacetKey.PRODUCTS_CASCADE]: 'Wärmeerzeuger Kaskade',
    [FacetKey.CONTROL_PLATFORMS]: 'Regelungsplattform',
  };

  protected readonly facetNodes = this._facade.facetNodes;

  protected updateFilters(key: FacetKey, facets: FacetNode[]) {
    this._facade.search(key, facets);
  }
}
